import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { SITE_URL } from '@/lib/seo';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />

      <div className="pt-16 bg-background-50 border-b border-background-200">
        <div className="w-full px-4 md:px-8 lg:px-12 py-3">
          <nav aria-label="breadcrumb">
            <ol className="flex items-center gap-2 text-sm text-foreground-500">
              <li><a href="/" className="hover:text-primary-600 transition-colors">Home</a></li>
              <li><i className="ri-arrow-right-s-line text-xs" /></li>
              <li><span className="text-foreground-700">Privacy Policy</span></li>
            </ol>
          </nav>
        </div>
      </div>

      <main className="flex-1 w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 max-w-4xl mx-auto">
        <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6">Privacy Policy</h1>
        <div className="text-foreground-700 leading-relaxed space-y-4">
          <p>
            This Privacy Policy describes how AllChinaBuy Spreadsheet handles information when you visit our website.
            We are committed to protecting your privacy and being transparent about our practices.
          </p>
          <h2 className="text-xl font-semibold text-foreground-900 mt-8 mb-2">Information We Collect</h2>
          <p>
            We do not collect personal information directly through this website. We may use standard analytics tools
            to understand website usage patterns, which may include anonymous data such as browser type, pages visited,
            and time spent on site. This data is not linked to any personally identifiable information.
          </p>
          <h2 className="text-xl font-semibold text-foreground-900 mt-8 mb-2">Cookies and Tracking</h2>
          <p>
            We may use cookies to improve your browsing experience and remember your language preferences.
            You can control cookie settings through your browser. We do not use third-party tracking cookies for advertising purposes.
          </p>
          <h2 className="text-xl font-semibold text-foreground-900 mt-8 mb-2">External Links</h2>
          <p>
            This website contains links to external websites, including our main website at kaspreadsheet.com.
            We are not responsible for the privacy practices of these external sites. We encourage you to review the privacy policies of any site you visit.
          </p>
          <h2 className="text-xl font-semibold text-foreground-900 mt-8 mb-2">Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated date.
          </p>
          <p className="text-sm text-foreground-500 mt-8">
            Last updated: August 26, 2026
          </p>
        </div>
      </main>

      <Footer />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Privacy Policy",
          "url": `${SITE_URL}/privacy-policy/`,
          "description": "Privacy policy for AllChinaBuy Spreadsheet describing how we handle information when you visit our website."
        })}
      </script>
    </div>
  );
}